import type { Notification } from './api';

export type NotificationTarget =
  | { kind: 'internal'; path: string }
  | { kind: 'external'; url: string };

type NotificationTargetInput = Pick<
  Notification,
  'action_url' | 'notification_type' | 'related_id'
>;

export function getNotificationTarget(n: NotificationTargetInput): NotificationTarget | null {
  if (n.action_url?.trim()) {
    const raw = n.action_url.trim();
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      return { kind: 'external', url: raw };
    }
    if (raw.startsWith('/app/')) return { kind: 'internal', path: raw };
    if (raw.startsWith('/')) return { kind: 'internal', path: `/app${raw}` };
    return { kind: 'internal', path: `/app/${raw}` };
  }

  switch (n.notification_type) {
    case 'support_comment':
      return {
        kind: 'internal',
        path: n.related_id ? `/app/support/requests/${n.related_id}` : '/app/support/requests',
      };
    case 'classified_pending':
    case 'classified_approved':
    case 'classified_declined':
      return {
        kind: 'internal',
        path: n.related_id ? `/app/classifieds/${n.related_id}` : '/app/classifieds',
      };
    case 'event_registration':
      return { kind: 'internal', path: '/app/events' };
    default:
      return null;
  }
}
